const mobileButton = document.getElementById('mobile-b');
const backendButton = document.getElementById('backend-b');
const frontendButton = document.getElementById('frontend-b');
// const designButton = document.getElementById('design-b');
const developmentButton = document.getElementById('development-b');
const mobile = document.getElementById('mobile-t');
const backend = document.getElementById('backend-t');
const frontend = document.getElementById('frontend-t');
// const design = document.getElementById('design-t');
const development = document.getElementById('development-t');
const x1_circle = document.getElementById('x1-circle');
const x2_circle = document.getElementById('x2-circle');
const x3_circle = document.getElementById('x3-circle');
const x4_circle = document.getElementById('x4-circle');
const x5_circle = document.getElementById('x5-circle');
// FIRST DEFAULT AND THEN HOVER SHOW EFFECT START
// for(let i=0;i<array.length;i++){
// console.log(array[i]);
// // if(array[i].classList.contain(''))
// }
// FIRST DEFAULT AND THEN HOVER SHOW EFFECT END
// FIRST DEFAULT AND THEN HOVER SHOW EFFECT START
// function designHover() {
//   const firstGridDesign = document.getElementById('first-grid-design');
//   const secondGridDesign = document.getElementById('second-grid-design');
//   const thirdGridDesign = document.getElementById('third-grid-design');
//   const forthGridDesign = document.getElementById('forth-grid-design');
//   const gridContainerDesign = document.getElementById('grid-container-design');
//   gridContainerDesign.addEventListener('mouseleave', () => {
//     firstGridDesign.classList.add('grid-split');
//   })
//   // sixthGrid.addEventListener('mouseover', () => {
//   //   firstGrid.classList.add('grid-split');
//   // })
//   const array1 = [firstGridDesign, secondGridDesign, thirdGridDesign, forthGridDesign];
//   array1.forEach((item, index) => {
//     item.addEventListener('mouseover', () => {
//       array1.forEach((gridItem, i) => {
//         if (index === i) {
//           gridItem.classList.add('grid-split');
//         } else {
//           gridItem.classList.remove('grid-split');
//         }
//       })
//     })
//     item.addEventListener('mouseleave', () => {
//       array1.forEach((gridItem, i) => {
//         gridItem.classList.remove('grid-split');
//       })
//     })
//   })
// }
// FIRST DEFAULT AND THEN HOVER SHOW EFFECT END
mobileButton.onclick = function() {
    if (mobile.style.display !== "none" && x1_circle.style.display !== "none") {
        mobile.style.display = "block";
        x1_circle.style.display = "block";
    } else {
        mobile.style.display = "block";
        x1_circle.style.display = "block";
        backend.style.display = "none";
        frontend.style.display = "none";
        development.style.display = "none";
    }
    developmentButton.style.background = "white";
    developmentButton.style.color = "black";
    mobileButton.style.background = "#5C3EB3";
    mobileButton.style.color = "white";
    backendButton.style.background = "white";
    backendButton.style.color = "black";
    frontendButton.style.background = "white";
    frontendButton.style.color = "black";
// designButton.style.background = "white";
// designButton.style.color = "black";
};
backendButton.onclick = function() {
    if (backend.style.display !== "none" && x2_circle.style.display !== "none") {
        backend.style.display = "block";
        x2_circle.style.display = "block";
    } else {
        backend.style.display = "block";
        x2_circle.style.display = "block";
        mobile.style.display = "none";
        frontend.style.display = "none";
        development.style.display = "none";
    }
    developmentButton.style.background = "white";
    developmentButton.style.color = "black";
    mobileButton.style.background = "white";
    mobileButton.style.color = "black";
    backendButton.style.background = "#5C3EB3";
    backendButton.style.color = "white";
    frontendButton.style.background = "white";
    frontendButton.style.color = "black";
// designButton.style.background = "white";
// designButton.style.color = "black";
};
frontendButton.onclick = function() {
    if (frontend.style.display !== "none" && x3_circle.style.display !== "none") {
        frontend.style.display = "block";
        x3_circle.style.display = "block";
    } else {
        frontend.style.display = "block";
        x3_circle.style.display = "block";
        backend.style.display = "none";
        development.style.display = "none";
        mobile.style.display = "none";
    }
    developmentButton.style.background = "white";
    developmentButton.style.color = "black";
    mobileButton.style.background = "white";
    mobileButton.style.color = "black";
    backendButton.style.background = "white";
    backendButton.style.color = "black";
    frontendButton.style.background = "#5C3EB3";
    frontendButton.style.color = "white";
// designButton.style.background = "whte";
// designButton.style.color = "black";
};
// if (designButton) {
//   designButton.onclick = function () {
//     if (design.style.display !== "none" && x4_circle.style.display !== "none") {
//       design.style.display = "block";
//       x4_circle.style.display = "block"
//     } else {
//       design.style.display = "block";
//       x4_circle.style.display = "block"
//     }
//   };
// }
developmentButton.onclick = function() {
    if (development.style.display !== "none" && x5_circle.style.display !== "none") {
        development.style.display = "block";
        x5_circle.style.display = "block";
    } else {
        development.style.display = "block";
        x5_circle.style.display = "block";
        development.style.display = "block";
        x5_circle.style.display = "block";
        backend.style.display = "none";
        frontend.style.display = "none";
        mobile.style.display = "none";
    }
    developmentButton.style.background = "#5C3EB3";
    developmentButton.style.color = "white";
    mobileButton.style.background = "white";
    mobileButton.style.color = "black";
    backendButton.style.background = "white";
    backendButton.style.color = "black";
    frontendButton.style.background = "white";
    frontendButton.style.color = "black";
};
// function opendropdown() {
//   var x = document.getElementById("dropdown");
//   if (x.style.display === "block") {
//     x.style.display = "none";
//   } else {
//     x.style.display = "block";
//   }
// }
// const getAndroidValue = document.getElementById('getAndroidVal');
// getAndroidValue.addEventListener('click', function getAndroidVal() {
//   window.location.href = "./hire-talent.html";
// })
// TRANSPARENT SCROLLING NAVBAR THEN WHITE NAVBAR EFFECT
function hellos() {
    if (development.style.display !== "none" && x5_circle.style.display !== "none") {
        development.style.display = "block";
        x5_circle.style.display = "block";
    } else {
        development.style.display = "block";
        x5_circle.style.display = "block";
        backend.style.display = "none";
        frontend.style.display = "none";
        mobile.style.display = "none";
    }
    mobileButton.style.background = "white";
    mobileButton.style.color = "black";
    developmentButton.style.background = "#5C3EB3";
    developmentButton.style.color = "white";
    backendButton.style.background = "white";
    backendButton.style.color = "black";
    frontendButton.style.background = "white";
    frontendButton.style.color = "black";
// designButton.style.background = "white";
// designButton.style.color = "black";
}
if (module.hot) {
    module.hot.dispose(function(data) {
        // module is about to be replaced.
        // You can save data that should be accessible to the new asset in `data`
        data.updated = Date.now();
    });
    module.hot.accept(function(getParents) {
        // module or one of its dependencies was just updated.
        // data stored in `dispose` is available in `module.hot.data`
        let { updated } = module.hot.data;
    });
}
window.designHover = designHover;
window.cloudHover = cloudHover;
window.hellos = hellos; // window.opendropdown = opendropdown;
 // window.getAndroidVal = getAndroidVal;

//# sourceMappingURL=investors-clinic.7c0a6a41.js.map
